import { render, staticRenderFns } from "./ProductDelList.vue?vue&type=template&id=9efba46a&scoped=true&"
import script from "./ProductDelList.vue?vue&type=script&lang=js&"
export * from "./ProductDelList.vue?vue&type=script&lang=js&"
import style0 from "./ProductDelList.vue?vue&type=style&index=0&id=9efba46a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efba46a",
  null
  
)

export default component.exports